import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useExamScoreStyle from "./styles";
import SidePannel from "./SidePannel";
import sidePannelData from "./sidePannelData";
import MyExam from "./ViewExam/Exam";
import Header from "./header";
import { useProfile } from "../../context/ProfileContext";
import { Typography, Box, Paper } from "@mui/material";
import JeeRegistrationPopup from "./JeeRegistrationPopup";

function DashboardMain() {
  const classes = useExamScoreStyle();
  const location = useLocation();
  const currentRoute = location.pathname;

  const [header, setHeader] = useState(sidePannelData);
  const [menuCollapse, setMenuCollapse] = useState(false);
  const { profile, fetchProfileData } = useProfile();
  const [open, setOpen] = useState(true);

  const user = {
    image: profile?.image_url || "N/A",
    rollNumber: profile?.learner_information?.roll_number || null,
    full_name: profile?.full_name || null,
  };

  const handleMenuCollapse = () => {
    setMenuCollapse(!menuCollapse);
  };

  useEffect(() => {
    fetchProfileData();
    if (sessionStorage.getItem("jeeDetails") !== "no") {
      setOpen(false);
    }
  }, []);

  // Function to render content based on current route
  const renderContent = () => {
    switch (currentRoute) {
      case "/myexam":
        return <MyExam />;
      default:
        return <div>404 - Page Not Found</div>; // optional fallback
    }
  };

  return (
    <div className={`${classes.dflex} ${classes.w100}`}>
      {/* <div
        className={`${menuCollapse ? classes.w5 : classes.w20} ${classes.shadowright}`}
      >
        <SidePannel
          menuCollapse={menuCollapse}
          header={header}
        />
      </div> */}

      <div
        className={`${menuCollapse ? classes.w100 : classes.w100} ${classes.h100vh
          }`}
      >
        <div className={classes.header}>
          <Header
            handleMenuCollapse={handleMenuCollapse}
            menuCollapse={menuCollapse}
          />
          {/* Main content wrapper */}
          <Box
            sx={{
              width: { xs: "95%", md: "90%", lg: "85%" },
              margin: "auto",
              paddingTop: "24px",
              paddingBottom: "24px",
              boxSizing: "border-box",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: 3,
                alignItems: "flex-start",
              }}
            >
              {/* Profile Card Sidebar */}
              <Paper
                elevation={0}
                sx={{
                  width: { xs: "100%", md: "260px", lg: "300px" },
                  flexShrink: 0,
                  p: 3,
                  borderRadius: "16px",
                  border: "1px solid rgba(15, 23, 42, 0.08)",
                  boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)",
                  background: "#ffffff",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  boxSizing: "border-box"
                }}
              >
                <Box
                  sx={{
                    width: "110px",
                    height: "110px",
                    borderRadius: "50%",
                    overflow: "hidden",
                    border: "3px solid #fff",
                    boxShadow: "0 8px 20px rgba(15, 23, 42, 0.1)",
                    mb: 2,
                    background: "#f1f5f9",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <img
                    src={user.image}
                    alt="Profile"
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null;
                      currentTarget.src = "userAvatar.png";
                    }}
                  />
                </Box>

                <Typography
                  variant="body2"
                  sx={{
                    color: "#64748b",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    fontSize: "0.75rem",
                  }}
                >
                  Welcome
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    color: "#0f172a",
                    fontWeight: 700,
                    mt: 0.5,
                    mb: 2.5,
                    fontSize: "1.1rem",
                  }}
                >
                  {user.full_name}
                </Typography>

                <Box
                  sx={{
                    width: "100%",
                    background: "#f8fafc",
                    borderRadius: "12px",
                    p: 2,
                    border: "1px solid #f1f5f9",
                    textAlign: "left",
                    boxSizing: "border-box"
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{ color: "#64748b", fontWeight: 500, fontSize: "0.75rem" }}
                  >
                    IBT ID / Roll Number
                  </Typography>
                  <Typography
                    variant="subtitle2"
                    sx={{ color: "#0f172a", fontWeight: 700, mt: 0.25, fontSize: "0.95rem" }}
                  >
                    {user.rollNumber}
                  </Typography>
                </Box>
              </Paper>

              {/* Main content right side */}
              <Box sx={{ flexGrow: 1, minWidth: 0, width: "100%" }}>
                {renderContent()}
              </Box>
            </Box>
          </Box>
        </div>
      </div>

      {/* <JeeRegistrationPopup open={open} handleClose={() => setOpen(false)} /> */}
    </div>
  );
}

export default DashboardMain;
